import React from 'react';
import { Truck, Clock, Package, MapPin, CreditCard, Shield } from 'lucide-react';

const Shipping = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Kargo & Teslimat
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Siparişlerinizin teslimat süreleri ve kargo bilgileri
          </p>
        </div>

        {/* Teslimat Seçenekleri */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center mb-4">
              <Truck className="h-8 w-8 text-orange-600 mr-3" />
              <h2 className="text-2xl font-bold text-gray-900">Standart Teslimat</h2>
            </div>
            <div className="space-y-4">
              <div className="flex items-start">
                <Clock className="h-5 w-5 text-gray-400 mr-3 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Teslimat Süresi</p>
                  <p className="text-gray-600">1-3 iş günü içinde</p>
                </div>
              </div>
              <div className="flex items-start">
                <Package className="h-5 w-5 text-gray-400 mr-3 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Kargo Ücreti</p>
                  <p className="text-gray-600">
                    300 TL ve üzeri siparişlerde ücretsiz, altında 50 TL
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-gray-400 mr-3 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Kapsam</p>
                  <p className="text-gray-600">Türkiye geneli Yurtiçi Kargo ile</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8 border-2 border-orange-500">
            <div className="flex items-center mb-4">
              <Truck className="h-8 w-8 text-orange-600 mr-3" />
              <h2 className="text-2xl font-bold text-gray-900">Hızlı Teslimat</h2>
              <span className="ml-auto bg-orange-100 text-orange-800 text-xs font-semibold px-3 py-1 rounded-full">
                İstanbul İçi
              </span>
            </div>
            <div className="space-y-4">
              <div className="flex items-start">
                <Clock className="h-5 w-5 text-gray-400 mr-3 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Teslimat Süresi</p>
                  <p className="text-gray-600">1-2 saat içinde</p>
                </div>
              </div>
              <div className="flex items-start">
                <Package className="h-5 w-5 text-gray-400 mr-3 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Kargo Ücreti</p>
                  <p className="text-gray-600">249 TL</p>
                </div>
              </div>
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-gray-400 mr-3 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-900">Kapsam</p>
                  <p className="text-gray-600">İstanbul il sınırları içi</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Kargo Süreci */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Sipariş Süreci</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">1</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Sipariş Ver</h3>
              <p className="text-sm text-gray-600">
                Ürünlerinizi seçin ve siparişinizi tamamlayın
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">2</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Onay</h3>
              <p className="text-sm text-gray-600">
                Siparişiniz kontrol edilir ve onaylanır
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">3</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Kargoya Ver</h3>
              <p className="text-sm text-gray-600">
                1-2 iş günü içinde kargoya verilir
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-orange-600">4</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Teslimat</h3>
              <p className="text-sm text-gray-600">
                Adresinize teslim edilir
              </p>
            </div>
          </div>
        </div>

        {/* Sık Sorulan Sorular */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Kargo Hakkında Sık Sorulan Sorular</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Siparişim ne zaman kargoya verilir?
              </h3>
              <p className="text-gray-600">
                Siparişleriniz genellikle 1-2 iş günü içinde kargoya verilir. Hafta sonları ve resmi tatillerde kargo işlemleri yapılmaz. Sipariş durumunuzu "Siparişlerim" sayfasından takip edebilirsiniz.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Kargo takip numarasını nasıl alırım?
              </h3>
              <p className="text-gray-600">
                Siparişiniz kargoya verildikten sonra, kargo takip numaranız e-posta adresinize gönderilir. Ayrıca "Siparişlerim" sayfasından da takip numaranızı görebilirsiniz.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Kargo ücreti ne kadar?
              </h3>
              <p className="text-gray-600">
                300 TL ve üzeri siparişlerde kargo ücretsizdir. 300 TL altındaki siparişlerde standart kargo ücreti 50 TL'dir. İstanbul içi hızlı teslimat için 249 TL ücret alınır.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Adres değişikliği yapabilir miyim?
              </h3>
              <p className="text-gray-600">
                Siparişiniz henüz kargoya verilmediyse adres değişikliği yapabilirsiniz. Bunun için müşteri hizmetlerimizle iletişime geçmeniz gerekmektedir.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Kargo takip nasıl yapılır?
              </h3>
              <p className="text-gray-600">
                Size gönderilen kargo takip numarası ile Yurtiçi Kargo web sitesinden veya mobil uygulamasından siparişinizi takip edebilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* Güvenlik Bilgileri */}
        <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg shadow-md p-8">
          <div className="flex items-center mb-4">
            <Shield className="h-8 w-8 text-orange-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-900">Güvenli Teslimat</h2>
          </div>
          <p className="text-gray-700 mb-4">
            Tüm siparişleriniz güvenli bir şekilde paketlenir ve teslim edilir. 
            Ürünleriniz hasar görmeden size ulaşması için özenle hazırlanır.
          </p>
          <p className="text-gray-700">
            Teslimat sırasında herhangi bir sorun yaşarsanız, lütfen müşteri hizmetlerimizle iletişime geçin.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Shipping;








